package com.taager.dukan.feature.quicklink

sealed class QuickLinkViewEvent {
    data class Init(val id: String) : QuickLinkViewEvent()
    object BackClick : QuickLinkViewEvent()
    data class EmailClick(val email: String) : QuickLinkViewEvent()
}
